import type { MediaGroup } from '../../../../models/user-generated-contents/types';

/**
 * Upserts a single media group within an attachments array.
 *
 * - Empty/undefined newItems: removes the group and re-indexes remaining orders.
 * - Group already present: replaces its items in place.
 * - Group absent: appends a new group at the end.
 *
 * Returns undefined when the resulting array would be empty.
 */
export function upsertAttachmentGroup(
  current: MediaGroup[],
  type: MediaGroup['type'],
  newItems: MediaGroup['items'] | undefined
): MediaGroup[] | undefined {
  if (!newItems || newItems.length === 0) {
    const rest = current.filter((g) => g.type !== type);
    return rest.length > 0
      ? rest.map((g, i) => ({ ...g, order: i }))
      : undefined;
  }
  if (current.some((g) => g.type === type)) {
    return current.map((g) =>
      g.type === type ? ({ ...g, items: newItems } as MediaGroup) : g
    );
  }
  return [
    ...current,
    {
      type,
      order: Math.max(...current.map((g) => g.order), -1) + 1,
      items: newItems,
    } as MediaGroup,
  ];
}
